/* istanbul ignore file */
export * from './footer.module';
export { FooterComponent } from './footer.component';
